import React from 'react';

const TriangleExclamation = props => {
    return (
        <svg {...props}>
            <path d="M 8.58,2.3 1.26,15 2.82,17.7 H 17.1 L 18.7,15 11.4,2.3 Z M 8.52,4.99 H 11.4 L 10.7,12.2 H 9.25 Z M 8.87,13.6 H 11 v 2.2 H 8.87 Z" />
        </svg>
    );
};
export default TriangleExclamation;
